export const ACCOUNT_TYPE = {
    STUDENT: "Student",
    INSTRUCTOR: "Instructor",
    ADMIN: "Admin",
  }
  
export const COURSE_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
}